import { Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Syncing State Component
 * Displayed when integrations are currently syncing
 */
export function SyncingState() {
  const { t } = useTranslation('authenticated.settings');

  return (
    <div className="flex w-full flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className="font-medium">{t('pages.integrations.status.title')}</span>
        <Loader className="h-4 w-4 animate-spin" />
      </div>
      <span className="text-sm text-muted-foreground">
        {t('pages.integrations.status.syncing.subtitle')}
      </span>
      <div className="mt-1 inline-flex items-center self-start rounded-full border border-chart-3 bg-background px-2.5 py-0.5 text-xs font-semibold text-chart-3 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
        {t('pages.integrations.status.syncing.badge')}
      </div>
    </div>
  );
}
